export const SHOW_DIALOG = 'SHOW_DIALOG'
export const HIDE_DIALOG = 'HIDE_DIALOG'

export const showDialog = (dialog) => {
    return {
        type: SHOW_DIALOG,
        dialog,
    }
}

export const hideDialog = () => {
    return {
        type: HIDE_DIALOG,
    }
}



// WEBPACK FOOTER //
// ./state/actions/CMT/Dialog.js